__turbopack_context__.v({
  "bottomSheet": "ModalCard-module-scss-module__Jo8XIa__bottomSheet",
  "fadeIn": "ModalCard-module-scss-module__Jo8XIa__fadeIn",
  "fullScreen": "ModalCard-module-scss-module__Jo8XIa__fullScreen",
  "hasFooter": "ModalCard-module-scss-module__Jo8XIa__hasFooter",
  "modalBody": "ModalCard-module-scss-module__Jo8XIa__modalBody",
  "modalContent": "ModalCard-module-scss-module__Jo8XIa__modalContent",
  "modalFooter": "ModalCard-module-scss-module__Jo8XIa__modalFooter",
  "modalHeader": "ModalCard-module-scss-module__Jo8XIa__modalHeader",
  "popIn": "ModalCard-module-scss-module__Jo8XIa__popIn",
  "slideUp": "ModalCard-module-scss-module__Jo8XIa__slideUp",
});
